const strings = {
  header: {
    employees: 'Employees',
    availableEmployees: 'Available Employees',
    availableEmployeesTooltip:
      'Total number of agents currently logged in and ready to accept new calls.',
  },
  cells: {
    fallbackWarningTooltip:
      'This queue has no rollover destination and a timeout under 30 minutes, so callers will be dropped if no agent answers.',
  },
} as const;

export default strings;
